/**
 * Hybrid ChatBubble Component
 * Automatically chooses between Tailwind and styled-components based on props
 */

import * as React from "react";
import { StyledChatBubble } from "./styles"; // Styled-components version
import { ChatBubbleTailwind } from "./ChatBubbleTailwind"; // Tailwind version
import { hasStyledProps } from "@sproutsocial/seeds-react-system-props";
import type { TypeChatBubbleProps } from "./ChatBubbleTypes";

const ChatBubbleHybrid = ({
  children,
  type = "received",
  size = "default",
  ...rest
}: TypeChatBubbleProps) => {
  if (hasStyledProps(rest)) {
    return (
      <StyledChatBubble type={type} size={size} data-qa-chat-bubble {...rest}>
        {children}
      </StyledChatBubble>
    );
  }

  // Use Tailwind version (preferred - better performance)
  return (
    <ChatBubbleTailwind type={type} size={size} {...rest}>
      {children}
    </ChatBubbleTailwind>
  );
};

export default ChatBubbleHybrid;
